import React from 'react'
import { Flex, Box } from 'grid-styled'
import styled from 'styled-components'
import Container from '../components/Container'
import smiley from '../images/smiley.svg'

const Row = props => <Flex {...props} mx={'-2vw'} />
const Column = props => <Box {...props} px={'2vw'} flex="1 1 auto" />

const StyledLink = styled.a`
  font-family: everett-regular, system-ui, sans-serif;
  font-size: 5.078125vw;
  letter-spacing: -0.1015625vw;
  margin-left: ${props => (props.margin ? '0.78125vw' : '0px')};
  color: #${props => (props.color ? props.color : 'inherit')};
  /* color: #fafafa; */
  text-decoration: none;

  @media (max-width: 40em) {
    font-size: 40px;
  }
`

const Smiley = styled.img`
  width: 3.59375vw;
  position: relative;
  top: 5px;
  margin-right: 1vw;
  @media (max-width: 40em) {
    width: 32px;
    /* top: 1px; */
  }
`

const TeamName = styled.p`
  font-family: everett-mono, system-ui, sans-serif;
  font-size: 1.5625vw;
  letter-spacing: -0.078125vw;
  line-height: 150%;
  color: #${props => (props.color ? props.color : 'inherit')};

  @media (max-width: 40em) {
    font-size: 17px;
    letter-spacing: -1px;
  }

  @media (min-width: 48em) and (max-width: 60em) {
    font-size: 17px;
    letter-spacing: -1px;
  }
`

const SubText = styled.p`
  font-family: everett-mono, system-ui, sans-serif;
  font-size: 1.5625vw;
  letter-spacing: -0.078125vw;
  line-height: 150%;
  color: #${props => (props.color ? props.color : 'inherit')};

  @media (max-width: 40em) {
    font-size: 17px;
    letter-spacing: -1px;
  }

  @media (min-width: 48em) and (max-width: 60em) {
    font-size: 17px;
    letter-spacing: -1px;
  }
`

const MailLink = styled.a`
  font-family: everett-mono, system-ui, sans-serif;
  font-size: 1.5625vw;
  letter-spacing: -0.078125vw;
  line-height: 150%;
  color: #${props => (props.color ? props.color : 'inherit')};
  /* color: rgba(250, 250, 250, 0.8); */
  text-decoration: none;

  @media (max-width: 40em) {
    font-size: 17px;
    letter-spacing: -1px;
  }

  @media (min-width: 48em) and (max-width: 60em) {
    font-size: 17px;
    letter-spacing: -1px;
  }
`

const Underline = styled.span`
  border-bottom: 1px solid #212121;
`

export default ({ color, bg }) => (
  <Container bg={bg} color={color}>
    <Row pb={'8vw'}>
      <Column
        width={10 / 12}
        ml={[0, 'calc(100% / 12 * 1)', 'calc(100% / 12 * 2)']}
        mr={[0, 'calc(100% / 12 * 1)', 'calc(100% / 12 * 2)']}
      >
        <Flex flexWrap={'wrap'} mb={[0]}>
          <StyledLink color={color} href="mailto:hello@feed.no">
            hello@feed.no
          </StyledLink>
        </Flex>
        <Flex flexWrap={'wrap'} mb={[0]}>
          <StyledLink
            color={color}
            href="https://goo.gl/maps/NJe5fQv89mx"
            target="_blank"
          >
            Thorvald Meyers Gate 72, 0552 Oslo
          </StyledLink>
        </Flex>
        <Flex flexWrap={'wrap'} mb={[4, 0]}>
          <StyledLink color={color} href="tel:+4790242622‬">
            +47 902 42 622
          </StyledLink>
        </Flex>
        <Flex flexWrap={'wrap'} mb={[0]}>
          <StyledLink
            color={color}
            href="https://www.instagram.com/feed_oslo/"
            target="_blank"
          >
            Instagram ·{' '}
          </StyledLink>
          <StyledLink
            color={color}
            margin
            href="https://www.facebook.com/feedoslo"
            target="_blank"
          >
            Facebook
          </StyledLink>
        </Flex>
        <Box mt={'9.0625vw'}>
          <Smiley src={smiley} alt="" />
          <StyledLink
            color={color}
            href="https://feed-as.homerun.co/"
            target="_blank"
          >
            We are hiring! <br />
            <Underline>View open postions.</Underline>
          </StyledLink>
        </Box>

        <Flex mt={[5, '9.0625vw']} flexWrap={'wrap'}>
          <Box width={1} mb={[2, 4]}>
            <SubText>Team:</SubText>
          </Box>
          <Box width={[12 / 12, 5 / 12]} mb={['30px', '3.828125vw']}>
            <TeamName>Rune Yndestad Møller</TeamName>
            <SubText>Managing Partner</SubText>
            <SubText>
              <MailLink color={color} href="mailto:rune@feed.no">
                rune@feed.no
              </MailLink>
            </SubText>
            <SubText>+47 902 42 622</SubText>
          </Box>
          <Box width={[12 / 12, 5 / 12]} mb={['30px', '3.828125vw']}>
            <TeamName>Fredrik Hæreid</TeamName>
            <SubText>Business Developer</SubText>
            <SubText>
              <MailLink color={color} href="mailto:fredrik.h@feed.no">
                fredrik.h@feed.no
              </MailLink>
            </SubText>
            <SubText>+47 970 82 280</SubText>
          </Box>
          <Box width={[12 / 12, 5 / 12]} mb={['30px', '3.828125vw']}>
            <TeamName>Henrik Wold Kraglund</TeamName>
            <SubText>Designer</SubText>
            <SubText>
              <MailLink color={color} href="mailto:henrik@feed.no">
                henrik@feed.no
              </MailLink>
            </SubText>
          </Box>
          <Box width={[12 / 12, 5 / 12]} mb={['30px', '3.828125vw']}>
            <TeamName>Oscar Grønner</TeamName>
            <SubText>Designer</SubText>
            <SubText>
              <MailLink color={color} href="mailto:oscar@feed.no">
                oscar@feed.no
              </MailLink>
            </SubText>
          </Box>
          <Box width={[12 / 12, 5 / 12]} mb={['30px', '3.828125vw']}>
            <TeamName>Mathilda Gustafsson</TeamName>
            <SubText>Designer</SubText>
            <SubText>
              <MailLink color={color} href="mailto:mathilda@feed.no">
                mathilda@feed.no
              </MailLink>
            </SubText>
          </Box>
          <Box width={[12 / 12, 5 / 12]} mb={['30px', '3.828125vw']}>
            <TeamName>Jens Johan Tandberg</TeamName>
            <SubText>Designer</SubText>
            <SubText>
              <MailLink color={color} href="mailto:jens@feed.no">
                jens@feed.no
              </MailLink>
            </SubText>
          </Box>
          <Box width={[12 / 12, 5 / 12]} mb={['30px', '3.828125vw']}>
            <TeamName>Mathias M. Stav</TeamName>
            <SubText>Developer</SubText>
            <SubText>
              <MailLink color={color} href="maiflto:mathias@feed.no">
                mathias@feed.no
              </MailLink>
            </SubText>
          </Box>

          <Box width={[12 / 12, 5 / 12]} mb={['30px', '3.828125vw']}>
            <TeamName>Helle Holmsen</TeamName>
            <SubText>Developer</SubText>
            <SubText>
              <MailLink color={color} href="mailto:oscar@feed.no">
                helle@feed.no
              </MailLink>
            </SubText>
          </Box>

          <Box width={[12 / 12, 5 / 12]} mb={['30px', '3.828125vw']}>
            <TeamName>Petter Edna</TeamName>
            <SubText>Developer</SubText>
            <SubText>
              <MailLink color={color} href="mailto:petter@feed.no">
                petter@feed.no
              </MailLink>
            </SubText>
          </Box>

          <Box width={[12 / 12, 5 / 12]} mb={['30px', '3.828125vw']}>
            <TeamName>Fredrik Søgaard</TeamName>
            <SubText>Product designer</SubText>
            <SubText>
              <MailLink color={color} href="mailto:fredrik.s@feed.no">
                fredrik.s@feed.no
              </MailLink>
            </SubText>
          </Box>
        </Flex>
      </Column>
    </Row>
  </Container>
)
